import { EditorState } from "draft-js";

import addBlock from "../../../../utils/addBlock";
import * as types from "../constants";

const addEmbedder = (editorState: EditorState, data = {}) =>
  addBlock(editorState, types.OEMBED_ADD_FORM_TYPE, data);

export default addEmbedder;
